export default __webpack_public_path__ + "img/45.53cee6.png";